/*


------

NOTE: 

Dont use colors from this file
This is being deprecated: use from tailwind.config.js

All Styles have to be applied using tailwind macro. No styled components.


Use src/Common/components/TailwindComponent.stories.ts as reference


------



*/
export const managerAppColors = {
   'gray-25': '#FCFCFD',
   'gray-50': '#F9FAFB',
   'gray-100': '#F2F4F7',
   'gray-200': '#EAECF0',
   'gray-300': '#D0D5DD',
   'gray-400': '#98A2B3',
   'gray-500': '#667085',
   'gray-600': '#475467',
   'gray-700': '#344054',
   'gray-800': '#1D2939',
   'gray-900': '#101828',
   'primary-25': '#F5FAFF',
   'primary-50': '#EFF8FF',
   'primary-100': '#D1E9FF',
   'primary-200': '#B2DDFF',
   'primary-300': '#84CAFF',
   'primary-400': '#53B1FD',
   'primary-500': '#2E90FA',
   'primary-600': '#1570EF',
   'primary-700': '#175CD3',
   'primary-800': '#1849A9',
   'primary-900': '#194185',
   'error-25': '#FFFBFA',
   'error-50': '#FEF3F2',
   'error-100': '#FEE4E2',
   'error-200': '#FECDCA',
   'error-300': '#FDA29B',
   'error-400': '#F97066',
   'error-500': '#F04438',
   'error-600': '#D92D20',
   'error-700': '#B42318',
   'error-800': '#912018',
   'error-900': '#7A271A',
   'warning-25': '#FFFCF5',
   'warning-50': '#FFFAEB',
   'warning-100': '#FEF0C7',
   'warning-200': '#FEDF89',
   'warning-300': '#FEC84B',
   'warning-400': '#FDB022',
   'warning-500': '#F79009',
   'warning-600': '#DC6803',
   'warning-700': '#B54708',
   'warning-800': '#93370D',
   'warning-900': '#7A2E0E',
   'success-25': '#F6FEF9',
   'success-50': '#ECFDF3',
   'success-100': '#D1FADF',
   'success-200': '#A6F4C5',
   'success-300': '#6CE9A6',
   'success-400': '#32D583',
   'success-500': '#12B76A',
   'success-600': '#039855',
   'success-700': '#027A48',
   'success-800': '#05603A',
   'success-900': '#054F31',
   'moss-25': '#FAFDF7',
   'moss-50': '#F5FBEE',
   'moss-100': '#E6F4D7',
   'moss-200': '#CEEAB0',
   'moss-300': '#ACDC79',
   'moss-400': '#86CB3C',
   'moss-500': '#669F2A',
   'moss-600': '#4F7A21',
   'moss-700': '#3F621A',
   'moss-800': '#335015',
   'moss-900': '#2B4212',
   'green-light-25': '#FAFEF5',
   'green-light-50': '#F3FEE7',
   'green-light-100': '#E3FBCC',
   'green-light-200': '#D0F8AB',
   'green-light-300': '#A6EF67',
   'green-light-400': '#85E13A',
   'green-light-500': '#66C61C',
   'green-light-600': '#4CA30D',
   'green-light-700': '#3B7C0F',
   'green-light-800': '#326212',
   'green-light-900': '#2B5314',

   'blue-light-25': '#F5FBFF',
   'blue-light-50': '#F0F9FF',
   'blue-light-100': '#E0F2FE',
   'blue-light-200': '#B9E6FE',
   'blue-light-300': '#7CD4FD',
   'blue-light-400': '#36BFFA',
   'blue-light-500': '#0BA5EC',
   'blue-light-600': '#0086C9',
   'blue-light-700': '#026AA2',
   'blue-light-800': '#065986',
   'blue-light-900': '#0B4A6F',

   'blue-dark-25': '#F5F8FF',
   'blue-dark-50': '#EFF4FF',
   'blue-dark-100': '#D1E0FF',
   'blue-dark-200': '#B2CCFF',
   'blue-dark-300': '#84ADFF',
   'blue-dark-400': '#528BFF',
   'blue-dark-500': '#2970FF',
   'blue-dark-600': '#155EEF',
   'blue-dark-700': '#004EEB',
   'blue-dark-800': '#0040C1',
   'blue-dark-900': '#00359E',
   'indigo-25': '#F5F8FF'
}

const colors = {
   'base-black': '#000000',
   'blue-gray-50': '#f8fafc',
   'base-white': '#ffffff',
   'blue-gray-500': '#64748b',
   'blue-gray-600': '#475569',
   'blue-gray-200': '#e2e8f0',
   'blue-gray-700': '#334155',
   'blue-gray-800': '#1e293b',
   'blue-gray-400': '#94a3b8',
   'blue-gray-900': '#0f172a',
   'blue-gray-300': '#cbd5e1',
   'blue-gray-100': '#f1f5f9',
   'red-50': '#fef2f2',
   'red-100': '#fee2e2',
   'red-200': '#fecaca',
   'red-300': '#fca5a5',
   'red-500': '#ef4444',
   'red-400': '#f87171',
   'red-600': '#dc2626',
   'red-700': '#b91c1c',
   'red-800': '#991b1b',
   'red-900': '#7f1d1d',
   'pink-50': '#fdf2f8',
   'pink-100': '#fce7f3',
   'pink-200': '#fbcfe8',
   'pink-300': '#f9a8d4',
   'pink-400': '#f472b6',
   'pink-500': '#ec4899',
   'pink-700': '#be185d',
   'pink-600': '#db2777',
   'pink-800': '#9d174d',
   'pink-900': '#831843',
   'fuchsia-50': '#fdf4ff',
   'fuchsia-100': '#fae8ff',
   'fuchsia-200': '#f5d0fe',
   'fuchsia-300': '#f0abfc',
   'fuchsia-400': '#e879f9',
   'fuchsia-500': '#d946ef',
   'fuchsia-600': '#c026d3',
   'fuchsia-700': '#a21caf',
   'fuchsia-800': '#86198f',
   'fuchsia-900': '#701a75',
   'purple-50': '#faf5ff',
   'purple-100': '#f3e8ff',
   'purple-200': '#e9d5ff',
   'purple-300': '#d8b4fe',
   'purple-400': '#c084fc',
   'purple-500': '#a855f7',
   'purple-600': '#9333ea',
   'purple-700': '#7e22ce',
   'purple-800': '#6b21a8',
   'purple-900': '#581c87',
   'violet-50': '#f5f3ff',
   'violet-100': '#ede9fe',
   'violet-200': '#ddd6fe',
   'violet-300': '#c4b5fd',
   'violet-400': '#a78bfa',
   'violet-500': '#8b5cf6',
   'violet-600': '#7c3aed',
   'violet-700': '#6d28d9',
   'violet-800': '#5b21b6',
   'violet-900': '#4c1d95',
   'indigo-50': '#eef2ff',
   'indigo-100': '#e0e7ff',
   'indigo-200': '#c7d2fe',
   'indigo-300': '#a5b4fc',
   'indigo-400': '#818cf8',
   'indigo-500': '#6366f1',
   'indigo-600': '#4f46e5',
   'indigo-700': '#4338ca',
   'indigo-800': '#3730a3',
   'indigo-900': '#312e81',
   'blue-50': '#eff6ff',
   'blue-100': '#dbeafe',
   'blue-200': '#bfdbfe',
   'blue-300': '#93c5fd',
   'blue-400': '#60a5fa',
   'blue-500': '#3b82f6',
   'blue-600': '#2563eb',
   'blue-700': '#1d4ed8',
   'blue-800': '#1e40af',
   'blue-900': '#1e3a8a',
   'cyan-50': '#ecfeff',
   'cyan-100': '#cffafe',
   'cyan-200': '#a5f3fc',
   'cyan-300': '#67e8f9',
   'cyan-400': '#22d3ee',
   'cyan-500': '#06b6d4',
   'cyan-600': '#0891b2',
   'cyan-700': '#0e7490',
   'teal-300': '#5eead4',
   'teal-50': '#f0fdfa',
   'cyan-800': '#155e75',
   'teal-200': '#99f6e4',
   'teal-100': '#ccfbf1',
   'cyan-900': '#164e63',
   'teal-500': '#14b8a6',
   'teal-600': '#0d9488',
   'teal-400': '#2dd4bf',
   'teal-800': '#115e59',
   'teal-700': '#0f766e',
   'teal-900': '#134e4a',
   'emerald-200': '#a7f3d0',
   'emerald-50': '#ecfdf5',
   'emerald-100': '#d1fae5',
   'emerald-500': '#10b981',
   'emerald-400': '#34d399',
   'emerald-300': '#6ee7b7',
   'emerald-600': '#059669',
   'emerald-700': '#047857',
   'emerald-800': '#065f46',
   'emerald-900': '#064e3b',
   'green-50': '#f0fdf4',
   'green-100': '#dcfce7',
   'green-200': '#bbf7d0',
   'green-300': '#86efac',
   'green-400': '#4ade80',
   'green-500': '#22c55e',
   'green-600': '#16a34a',
   'green-700': '#15803d',
   'green-800': '#166534',
   'green-900': '#14532d',
   'lime-50': '#f7fee7',
   'lime-100': '#ecfccb',
   'lime-200': '#d9f99d',
   'lime-300': '#bef264',
   'lime-400': '#a3e635',
   'lime-500': '#84cc16',
   'lime-700': '#4d7c0f',
   'lime-600': '#65a30d',
   'lime-800': '#3f6212',
   'lime-900': '#365314',
   'yellow-50': '#fefce8',
   'yellow-100': '#fef9c3',
   'yellow-200': '#fef08a',
   'yellow-300': '#fde047',
   'yellow-400': '#facc15',
   'yellow-500': '#eab308',
   'yellow-600': '#ca8a04',
   'yellow-700': '#a16207',
   'yellow-800': '#854d0e',
   'yellow-900': '#713f12',
   'amber-50': '#fffbeb',
   'amber-100': '#fef3c7',
   'amber-200': '#fde68a',
   'amber-300': '#fcd34d',
   'amber-400': '#fbbf24',
   'amber-500': '#f59e0b',
   'amber-600': '#d97706',
   'amber-700': '#b45309',
   'amber-800': '#92400e',
   'orange-50': '#fff7ed',
   'amber-900': '#78350f',
   'orange-100': '#ffedd5',
   'orange-200': '#fed7aa',
   'orange-300': '#fdba74',
   'orange-400': '#fb923c',
   'orange-500': '#f97316',
   'orange-600': '#ea580c',
   'orange-700': '#c2410c',
   'orange-800': '#9a3412',
   'orange-900': '#7c2d12',
   'rose-50': '#fff1f2',
   'rose-100': '#ffe4e6',
   'rose-200': '#fecdd3',
   'rose-300': '#fda4af',
   'rose-400': '#fb7185',
   'rose-500': '#f43f5e',
   'rose-600': '#e11d48',
   'rose-800': '#9f1239',
   'rose-900': '#881337',
   'rose-700': '#be123c',
   'orange-dark-25': '#FFF9F5',
   'orange-dark-50': '#FFF4ED',
   'orange-dark-100': '#FFE6D5',
   'orange-dark-200': '#FFD6AE',
   'orange-dark-300': '#FF9C66',
   'orange-dark-400': '#FF692E',
   'orange-dark-500': '#FF4405',
   'orange-dark-600': '#E62E05',
   'orange-dark-700': '#BC1B06',
   'orange-dark-800': '#97180C',
   'orange-dark-900': '#771A0D',
   'glass-white': 'rgba(255, 255, 255, 0.24)',
   'glass-black': 'rgba(0, 0, 0, 0.24)',
   'transparent-primary-4': 'rgba(9, 103, 210, 0.04)',
   transparent: 'rgba(0, 0, 0, 0)',
   'light-blue-500': '#0EA5E9',
   ...managerAppColors
}

export { colors }
